import React from 'react';
import {KnowledgeSkillsAndAbilitiesSelect} from './KnowledgeSkillsAndAbilitiesSelect';

export const KnowledgeSkillsAndAbilitiesWithInfoSelect = () => {
  return <KnowledgeSkillsAndAbilitiesSelect infoText="Choose a competency first." />;
};
